<template>
  <div class="my-info-page">
    <!-- 头部用户信息卡片 -->
    <div class="user-card">
      <div class="avatar">{{ getFirstLetter() }}</div>
      <div class="user-info">
        <div class="name">{{ userInfo.username }}</div>
        <div class="uid">{{ $t('lang.my.uid') }} {{ userInfo.showId }}</div>
      </div>
      <div class="edit-icon" @click="goto('EditProfile')">
        <img src="../../assets/images/my/edit.svg" alt=""/>
      </div>
    </div>

    <!-- 绑定手机模块 -->
    <div class="bind-phone-box" v-if="!userInfo.mobileNo">
      <div class="bind-left">
        <div class="shield-icon">
          <img src="../../assets/images/my/overlay.svg" alt=""/>
        </div>
        <div class="bind-text">
          <div class="title">{{ $t('lang.my.bindTitle') }}</div>
          <div class="desc">{{ $t('lang.my.bindDesc') }}</div>
        </div>
      </div>
      <div class="bind-btn" @click="goto('BindPhone')">{{ $t('lang.my.bindPhone') }}</div>
    </div>

    <!-- 余额钱包卡片 -->
    <div class="wallet-card">
      <div class="wallet-top">
        <div class="balance-label">{{ $t('lang.my.availableBalance') }}</div>
        <div class="wallet-history">{{ $t('lang.my.walletHistory') }}</div>
      </div>
      <div class="balance-row">
        <div class="coin-icon">
          <img src="../../assets/images/my/badge.svg" alt=""/>
        </div>
        <div class="balance-num">{{ separateThousandInteger(userInfo.userBalance.availableBalance) }}<span
          class="bc-text">BC</span></div>
      </div>
      <div class="rate-text">≈ ₹{{ separateThousand(userInfo.userBalance.availableBalance) / 100 }} 100 BC = ₹1</div>
      <div class="wallet-buttons">
        <div class="btn withdraw-btn">{{ $t('lang.my.withdraw') }}</div>
        <div class="btn addfunds-btn" @click="goto('wallet')">{{ $t('lang.my.fund') }}</div>
      </div>
    </div>

    <!-- 功能列表项 -->
    <div class="list-item">
      <div class="item-icon blue">
        <img src="../../assets/images/my/txt.svg" alt=""/>
      </div>
      <div class="item-text">
        <div class="item-title">{{ $t('lang.my.myTraining') }} <span class="tag">{{ $t('lang.my.activeTag') }}</span>
        </div>
        <div class="item-desc">{{ $t('lang.my.dailyProgress') }}</div>
      </div>
      <div class="item-right" @click="goto('Training')">
        <span class="continue-text">{{ $t('lang.my.continueBtn') }}</span>
        <span class="arrow"><img src="../../assets/images/my/next.svg" alt=""/></span>
      </div>
    </div>

    <div class="list-item">
      <div class="item-icon yellow">
        <img src="../../assets/images/my/gift.svg" alt=""/>
      </div>
      <div class="item-text">
        <div class="item-title">{{ $t('lang.my.inviteEarn') }}</div>
        <div class="item-desc">{{ $t('lang.my.inviteDesc') }}</div>
      </div>
      <div class="item-right" @click="goto('Invite')">
        <span class="dot"></span>
        <span class="arrow"><img src="../../assets/images/my/next.svg" alt=""/></span>
      </div>
    </div>

    <div class="listBox">
      <div class="list-item list-item-divider">
        <div class="item-icon">
          <img src="../../assets/images/my/Background0.svg" alt=""/>
        </div>
        <div class="item-text">
          <div class="item-title">{{ $t('lang.my.notifications') }}</div>
        </div>
        <div class="item-right">
          <span class="dot"></span>
          <span class="arrow"><img src="../../assets/images/my/next.svg" alt=""/></span>
        </div>
      </div>

      <div class="list-item list-item-divider">
        <div class="item-icon">
          <img src="../../assets/images/my/Background1.svg" alt=""/>
        </div>
        <div class="item-text">
          <div class="item-title">{{ $t('lang.my.helpSupport') }}</div>
        </div>
        <div class="item-right">
          <span class="side-desc">{{ $t('lang.my.faqsTicket') }}</span>
          <span class="arrow"><img src="../../assets/images/my/next.svg" alt=""/></span>
        </div>
      </div>
    </div>

    <div class="listBox">
      <div class="list-item list-item-divider">
        <div class="item-icon">
          <img src="../../assets/images/my/Background2.svg" alt=""/>
        </div>
        <div class="item-text">
          <div class="item-title">{{ $t('lang.my.withdrawAccount') }}</div>
          <div class="item-desc">{{ $t('lang.my.bankDesc') }}</div>
        </div>
        <div class="item-right">
          <span class="arrow"><img src="../../assets/images/my/next.svg" alt=""/></span>
        </div>
      </div>

      <div class="list-item list-item-divider" v-if="false">
        <div class="item-icon">
          <img src="../../assets/images/my/Background3.svg" alt=""/>
        </div>
        <div class="item-text">
          <div class="item-title">{{ $t('lang.my.language') }}</div>
        </div>
        <div class="item-right">
          <span class="side-desc">{{ $t('lang.my.englishIndia') }}</span>
          <span class="arrow"><img src="../../assets/images/my/next.svg" alt=""/></span>
        </div>
      </div>

      <div class="list-item list-item-divider" @click="goto('Terms')">
        <div class="item-icon">
          <img src="../../assets/images/my/Background4.svg" alt=""/>
        </div>
        <div class="item-text">
          <div class="item-title">{{ $t('lang.my.termsOfService') }}</div>
        </div>
        <div class="item-right">
          <span class="arrow"><img src="../../assets/images/my/next.svg" alt=""/></span>
        </div>
      </div>

      <div class="list-item list-item-divider">
        <div class="item-icon">
          <img src="../../assets/images/my/Background5.svg" alt=""/>
        </div>
        <div class="item-text">
          <div class="item-title">{{ $t('lang.my.privacyPolicy') }}</div>
        </div>
        <div class="item-right">
          <span class="arrow"><img src="../../assets/images/my/next.svg" alt=""/></span>
        </div>
      </div>

      <div class="list-item list-item-divider">
        <div class="item-icon">
          <img src="../../assets/images/my/Background6.svg" alt=""/>
        </div>
        <div class="item-text">
          <div class="item-title">{{ $t('lang.my.version') }}</div>
        </div>
        <div class="item-right">
          <span class="side-desc">{{ $t('lang.my.versionNum') }}</span>
        </div>
      </div>
    </div>

    <!-- 退出登录按钮 -->
    <div class="logout-btn" @click="logout()">
      <img src="../../assets/images/my/logout.svg" alt=""/>
      {{ $t('lang.my.logout') }}
    </div>
  </div>
</template>

<script>
import {separateThousand, separateThousandInteger} from '@/utils'
import {mapMutations} from 'vuex'
import request from '@/service'

export default {
  name: 'My',
  data () {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo'))
    }
  },
  watch: {},
  mounted () {
    if (!this.userInfo) {
      this.goto('Login')
    }
  },
  beforeDestroy () {
  },
  methods: {
    ...mapMutations({
      setCurrentRoute: 'setCurrentRoute',
      setInternationName: 'setInternationName',
      setInternation: 'setInternation'
    }),
    separateThousand,
    separateThousandInteger,
    logout () {
      // 调用后端登出接口
      request('post', '/api/account/logout', {}).then(() => {
        // 无论接口成功失败，都清除本地数据
        this.clearLocalAndRedirect()
      }).catch(() => {
        this.clearLocalAndRedirect()
      })
    },
    clearLocalAndRedirect () {
      localStorage.removeItem('userInfo')
      localStorage.removeItem('modals')
      localStorage.removeItem('LHP')
      this.$router.go(0)
    },
    getFirstLetter () {
      return this.userInfo.username.charAt(0).toUpperCase()
    },
    goto (route) {
      this.$router.push(route)
    }
  }
}
</script>
<style lang='less' scoped>
.my-info-page {
  height: 100dvh;
  overflow: auto;
  position: relative;
  overflow-x: hidden;
  padding: calc(60vw / 3.6) calc(16vw / 3.6) calc(64vw / 3.6) calc(16vw / 3.6);
  background: var(--background);
}

.user-card {
  position: relative;
  margin-top: calc(10vw / 3.6);
  left: 50%;
  transform: translate(-50%);
  background: #ffffff;
  height: calc(86vw / 3.6);
  border-radius: calc(16vw / 3.6);
  padding: calc(20vw / 3.6) calc(16vw / 3.6);
  display: flex;
  align-items: center;
  gap: calc(14vw / 3.6);
  margin-bottom: calc(14vw / 3.6);
  box-shadow: 0px 1px 3px -1px #0F172A05;
  box-shadow: 0px 2px 8px -1px #0F172A0A;

  .avatar {
    position: relative;
    top: 0;
    font-family: Inter;
    width: calc(52vw / 3.6);
    height: calc(52vw / 3.6);
    border-radius: 50%;
    background-color: #EFF6FF;
    color: var(--footerAct);
    font-size: calc(20vw / 3.6);
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    border: calc(2vw / 3.6) solid rgba(47, 107, 255, 0.2);

    &::after {
      position: absolute;
      bottom: calc(0vw / 3.6);
      right: calc(0vw / 3.6);
      content: "";
      width: calc(10vw / 3.6);
      height: calc(10vw / 3.6);
      background: #10B981;
      border-radius: 50%;
      border: calc(2vw / 3.6) solid #fff;
    }
  }

  .user-info {
    flex: 1;

    .name {
      font-size: calc(16vw / 3.6);
      margin-bottom: calc(4vw / 3.6);
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      letter-spacing: -0.04em;
      color: #0F172A;
    }

    .uid {
      font-size: calc(12vw / 3.6);
      color: #777;
    }
  }

  .edit-icon {
    width: calc(36vw / 3.6);
    height: calc(36vw / 3.6);
    border-radius: 50%;
    background: #f3f4f6;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.bind-phone-box {
  background: #e8f0fe;
  border-radius: calc(14vw / 3.6);
  height: calc(58vw / 3.6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: calc(14vw / 3.6) 0;
  padding: 0 calc(13vw / 3.6);

  .bind-left {
    display: flex;
    align-items: center;
    gap: calc(10vw / 3.6);
  }

  .bind-text {
    .title {
      font-size: calc(12vw / 3.6);
      letter-spacing: -0.0025em;
      color: var(--bind-text);
      font-family: Inter;
      font-weight: 700;
      white-space: nowrap;
    }

    .desc {
      margin-top: calc(2vw / 3.6);
      font-weight: 400;
      font-size: calc(10vw / 3.6);
      color: var(--text1);
      white-space: nowrap;
    }
  }

  .bind-btn {
    background: #2563eb;
    color: #fff;
    width: calc(101vw / 3.6);
    height: calc(29vw / 3.6);
    line-height: calc(29vw / 3.6);
    border-radius: calc(10vw / 3.6);
    font-family: Inter;
    font-size: calc(11vw / 3.6);
    font-weight: 700;
    text-align: center
  }
}

.wallet-card {
  background: #ffffff;
  height: calc(172.5vw / 3.6);
  border-radius: calc(16vw / 3.6);
  padding: calc(17vw / 3.6);
  margin-bottom: calc(14vw / 3.6);
  box-shadow: 0px 1px 3px -1px #0F172A05;
  box-shadow: 0px 2px 8px -1px #0F172A0A;

  .wallet-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: calc(12vw / 3.6);

    .balance-label {
      font-size: calc(11vw / 3.6);
      font-family: 'Inter';
      font-weight: 700;
      letter-spacing: 0.05em;
      text-transform: uppercase;
      color: #94A3B8;
    }

    .wallet-history {
      font-size: calc(12vw / 3.6);
      font-weight: 700;
      font-size: 12px;
    }
  }

  .balance-row {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .balance-num {
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      font-size: calc(24vw / 3.6);
      line-height: calc(24vw / 3.6);
      margin-left: calc(8vw / 3.6);;
      letter-spacing: -0.002vw;
      color: var(--black);

      .bc-text {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 700;
        font-size: calc(14vw / 3.6);
        color: #475569;
      }
    }
  }

  .rate-text {
    font-size: calc(15vw / 3.6);
    color: #777;
    margin: calc(6vw / 3.6) 0 calc(10vw / 3.6);
  }

  .wallet-buttons {
    display: flex;
    justify-content: space-evenly;
    align-items: center;

    .btn {
      font-family: 'Inter';
      font-weight: 700;
      text-align: center;
      height: calc(44vw / 3.6);
      line-height: calc(44vw / 3.6);
      width: calc(126vw / 3.6);
      border-radius: calc(14vw / 3.6);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: calc(12vw / 3.6);
    }

    .withdraw-btn {
      background: #2563eb;
      color: #fff;
    }

    .addfunds-btn {
      background: #ffffff;
      color: #333;
      border: calc(1vw / 3.6) solid #ddd;
    }
  }
}

.list-item {
  background: #FFFFFF;
  border-radius: calc(14vw / 3.6);
  padding: calc(16vw / 3.6);
  display: flex;
  align-items: center;
  gap: calc(12vw / 3.6);
  margin-bottom: calc(10vw / 3.6);
  box-shadow: 0px 1px 3px -1px #0F172A05;
  box-shadow: 0px 2px 8px -1px #0F172A0A;

  .item-icon {
    width: calc(32vw / 3.6);
    height: calc(32vw / 3.6);
    border-radius: calc(10vw / 3.6);
    display: flex;
    align-items: center;
    justify-content: center;

    &.blue {
      background: #e8f0fe;
    }

    &.yellow {
      background: #fff6e6;
    }
  }

  .item-text {
    flex: 1;

    .item-title {
      font-size: calc(12vw / 3.6);
      font-family: 'Inter';
      font-weight: 700;
      color: #1E293B;

      .tag {
        position: absolute;
        background: #dbeafe;
        font-size: calc(10vw / 3.6);
        padding: calc(3vw / 3.6) calc(8vw / 3.6);
        border-radius: calc(12vw / 3.6);
        margin-left: calc(6vw / 3.6);
        white-space: nowrap;
        font-family: 'Inter';
        font-weight: 700;
        color: var(--footerAct);
      }
    }

    .item-desc {
      font-size: calc(11vw / 3.6);
      margin-top: calc(3vw / 3.6);
      font-family: 'Liberation Sans';
      font-weight: 400;
      color: var(--text2);
    }
  }

  .item-right {
    display: flex;
    align-items: center;
    gap: calc(6vw / 3.6);

    .continue-text {
      color: #2563eb;
      font-size: calc(12vw / 3.6);
      font-weight: 700;
      color: #0051DF;
    }

    .side-desc {
      font-size: calc(11vw / 3.6);
      font-family: 'Liberation Sans';
      font-style: normal;
      font-weight: 400;
      color: var(--text2);
    }

    .dot {
      width: calc(8vw / 3.6);
      height: calc(8vw / 3.6);
      border-radius: 50%;
      background: #2563eb;
    }

    .arrow {
      color: #aaa;
      font-size: calc(18vw / 3.6);
    }
  }
}

.list-item-divider {
  position: relative;
  border-radius: 0 !important;
  margin-bottom: 0 !important;
  box-shadow: none;
  border-bottom: calc(1vw / 3.6) solid var(--bottom) !important;
}

.listBox {
  width: calc(328vw / 3.6);
  height: max-content;
  box-shadow: 0px 1px 3px -1px #0F172A05;
  box-shadow: 0px 2px 8px -1px #0F172A0A;
  border-radius: calc(14vw / 3.6);
  margin-bottom: calc(10vw / 3.6);
  overflow: hidden;
}

.logout-btn {
  margin: calc(13vw / 3.6) 0;
  background: #fff;
  border: calc(1vw / 3.6) solid #fecaca;
  color: #ed4343;
  border-radius: calc(12vw / 3.6);
  height: calc(44vw / 3.6);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: calc(8vw / 3.6);
  font-size: calc(18vw / 3.6);
  font-weight: 500;
}

</style>



// WEBPACK FOOTER //
// src/pages/My/index.vue